import {makeStyles} from "@material-ui/core"

export default makeStyles({
    dialog: {
        width: 400,
    },
    actions: {
        justifyContent: "flex-end",
    },
    seconds: {
        fontFamily: "Roboto",
        fontSize: 24,
        fontWeight: 600,
    },
    warning_text: {},
})
